import { render, staticRenderFns } from "./UnSupportedUserError.vue?vue&type=template&id=a037722c&"
import script from "./UnSupportedUserError.vue?vue&type=script&lang=ts&"
export * from "./UnSupportedUserError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports